import {
  Component,
  OnInit,
  AfterViewInit,
  OnChanges,
  Input,
  SimpleChanges,
  OnDestroy,
  ChangeDetectorRef
} from "@angular/core";
import { DataService } from "./data.service";
import * as Highcharts from "highcharts";
import addMore from "highcharts/highcharts-more";
import { TranslateService } from "@ngx-translate/core";
import { WidgetConfig } from "../../../class/widget-config";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { GenericUtils } from "../../../utilities/generic-utils";
import { Router } from "@angular/router";

addMore(Highcharts);
@Component({
  selector: 'stack-column-chart-with-lines',
  templateUrl: './stack-column-chart-with-lines.component.html',
  styleUrls: ['./stack-column-chart-with-lines.component.scss'],
  providers: [DataService]
})
export class StackColumnChartWithLinesComponent implements OnInit, OnChanges, OnDestroy {
  @Input() FILTERS;
  @Input() WIDGETCONFIG: WidgetConfig;
  @Input() CHARTCONFIG;
  highcharts: typeof Highcharts = Highcharts;
  chartOptions = null;
  tempChartOptions = null;
  errorMessage = "";
  mockChart = null;
  loadingChart = false;
  errorLoadingChart = false;
  plotLines = null;
  private unsubscribe: Subject<void> = new Subject();
  abc;
  tempChartOpt;
  displayText;
  message = ''
  constructor(
    private translateService: TranslateService,
    private dataService: DataService,
    private cd: ChangeDetectorRef,
    private utils: GenericUtils,
    private router: Router
  ) { }



  ngOnChanges(changes: SimpleChanges) {
    this.getData();
    if (this.router.url.includes('outbound') || this.router.url.includes('inbound')) {
      this.message = this.router.url.includes('outbound') ? 'WAREHOUSE.HIGHLIGHT_OUTBOUND_MSG' : 'WAREHOUSE.HIGHLIGHT_INBOUND_MSG';
    }
    if (this.WIDGETCONFIG['config']['apis'] && !this.plotLines) {
      this.getLineData();
    }
  }

  ngOnInit() { }

  getLineData() {
    this.dataService.getLineData(this.WIDGETCONFIG['config']['apis'][0]).pipe(takeUntil(this.unsubscribe)).subscribe((response) => {

      if (response.data) {
        const originalData = response.data[0][Object.keys(response.data[0])[0]][0];
        this.plotLines = [{
          dashStyle: "ShortDash",
          color: "#979797",
          width: 2,
          value: Number(originalData.yesterday_sla.toFixed(2)),
          zIndex: 4,
          label: {
            text: `Yesterday SLA (${Number(originalData.yesterday_sla.toFixed(2))}%)`,
            align: 'right',
            style: {
              color: '#979797',
              fontWeight: '900',
              fontSize: '10px',
              textShadow: '0px 0px 3px white'
            }
          }
        },
        {
          dashStyle: "ShortDash",
          color: "#979797",
          width: 2,
          zIndex: 4,
          value: Number(originalData.curr_month_sla.toFixed(2)),
          label: {
            text: `Month to Date SLA (${Number(originalData.curr_month_sla.toFixed(2))}%)`,
            align: 'right',
            style: {
              color: '#979797',
              fontWeight: '900',
              fontSize: '10px',
              textShadow: '0px 0px 3px white',

            }
          },

        }];
        const condition = Math.abs(originalData.yesterday_sla - originalData.curr_month_sla) < 5;
        if (originalData.yesterday_sla >= originalData.curr_month_sla && condition) {
          this.plotLines[1].label.y = 10;
        } else if (condition) {
          this.plotLines[0].label.y = 10;
        }

        
        if (this.tempChartOptions) { //TempChartOptions have to be used as making chartoptions null and then reassigning it with deepcopy is not work ... it seems as if highcharts is maintaining a local copy of the chartOPtions even when I assign it null.
          this.tempChartOptions['yAxis'][0]['plotLines'] = this.plotLines;
          this.chartOptions = this.utils.deepCopyFunction(this.tempChartOptions);
        }
        this.CHARTCONFIG[0]['yAxis'][0]['plotLines'] = this.plotLines;
      }

    });

  }
  getData() {
    this.chartOptions = null;
    this.errorMessage = "";
    this.mockChart = null;
    this.loadingChart = true;
    this.errorLoadingChart = false;
    this.dataService.getData(this.WIDGETCONFIG.api, this.WIDGETCONFIG, this.FILTERS)
      .pipe(takeUntil(this.unsubscribe)).subscribe(
        chartData => {
          this.loadingChart = false;
          if (chartData) {
            this.tempChartOptions  = this.dataService.createChart(
              chartData,
              this.CHARTCONFIG
            );
            this.displayText = chartData.displayText;
            if (this.plotLines) {
              this.tempChartOptions.yAxis[0]['plotLines'] = this.plotLines;
              this.chartOptions = this.utils.deepCopyFunction(this.tempChartOptions);
            }
          } else {
            this.handleError("ERROR_MSG.NO_DATA");
          }
        },
        error => {
          this.loadingChart = false;
          this.handleError("ERROR_MSG.SYSTEM_ERROR");
        }
      );
  }

  handleError(message) {
    this.errorLoadingChart = true;
    this.errorMessage = message;
    this.mockChart = [{ chart: this.CHARTCONFIG[0], width: 12 }];

  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
